// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__rJvAo","closeHolder":"Modal_closeHolder__Lc5ZB","closeButton":"Modal_closeButton__TaNyx"};